/* ======================================================
   AFINA homepage interactivity (vanilla, no framework)
   Powers: video/article/report modals, accordions, review
   tabs, and horizontal rail scrolling. Uses event delegation
   so it works for every Afina section on the page.
   ====================================================== */
(function () {
  'use strict';

  /* ---- Modal overlay (created once, reused) ---- */
  var overlay, overlayBox, overlayContent;
  function buildOverlay() {
    if (overlay) return overlay;
    // Fully self-contained overlay. The store's theme (and Bootstrap) define their
    // own ".modal"/".modal__box" with !important, which beats plain inline styles and
    // wrecked centering/sizing. So we use afina-prefixed class names the theme never
    // targets AND pin every layout-critical property inline with !important. Height is
    // auto with a max-height + internal scroll so content never clips. Wrapper carries
    // .afina-home for token vars + fonts (and scopes the content styles below).
    var wrap = document.createElement('div');
    wrap.className = 'afina-home';
    overlay = document.createElement('div');
    overlay.className = 'afina-modal';
    overlay.style.cssText = 'position:fixed !important;inset:0 !important;z-index:2147483647 !important;display:flex !important;align-items:center !important;justify-content:center !important;padding:24px !important;box-sizing:border-box !important;margin:0 !important;opacity:0;pointer-events:none;transition:opacity .2s ease;';
    var scrim = document.createElement('div');
    scrim.setAttribute('data-afina-close', '');
    scrim.style.cssText = 'position:absolute !important;inset:0 !important;background:rgba(14,14,11,.6) !important;backdrop-filter:blur(3px);border:0 !important;margin:0 !important;';
    overlayBox = document.createElement('div');
    overlayBox.className = 'afina-modal__box';
    overlayBox.setAttribute('role', 'dialog');
    overlayBox.setAttribute('aria-modal', 'true');
    overlayBox.style.cssText = 'position:relative !important;background:#fff !important;border-radius:20px !important;width:100% !important;max-width:760px !important;height:auto !important;max-height:90vh !important;overflow-y:auto !important;overflow-x:hidden !important;padding:34px !important;box-shadow:0 28px 64px -28px rgba(20,18,12,.5) !important;box-sizing:border-box !important;margin:0 !important;transform:none !important;flex:0 1 auto !important;';
    var close = document.createElement('button');
    close.className = 'afina-modal__close';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-afina-close', '');
    close.style.cssText = 'position:absolute !important;top:16px !important;right:16px !important;width:34px !important;height:34px !important;border-radius:999px !important;border:1px solid #eae9e4 !important;background:#fff !important;display:flex !important;align-items:center !important;justify-content:center !important;cursor:pointer !important;color:#25231c !important;z-index:2 !important;padding:0 !important;';
    close.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="pointer-events:none"><path d="M18 6L6 18M6 6l12 12"/></svg>';
    overlayContent = document.createElement('div');
    overlayContent.className = 'afina-modal__content';
    overlayBox.appendChild(close);
    overlayBox.appendChild(overlayContent);
    overlay.appendChild(scrim);
    overlay.appendChild(overlayBox);
    wrap.appendChild(overlay);
    document.body.appendChild(wrap);
    overlay.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-afina-close')) closeModal();
    });
    return overlay;
  }
  function openModal(html, small) {
    buildOverlay();
    overlayContent.innerHTML = html;
    overlayBox.style.setProperty('max-width', small ? '460px' : '760px', 'important');
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    if (!overlay) return;
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    document.documentElement.style.overflow = '';
    var v = overlay.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    overlayContent.innerHTML = '';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); closeInfoDrawer(); }
  });

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---- PDP InfoDrawer (Issues / Install / Clinical quicklinks) ---- */
  var INFO_TITLES = { issues: 'Benefits for Your Hair & Skin', install: 'How to Install', clinical: 'Clinical Studies' };
  function openInfoDrawer(tab) {
    var drawer = document.querySelector('[data-afina-info-drawer]');
    if (!drawer) return;
    var scrim = document.querySelector('[data-afina-info-scrim]');
    drawer.querySelectorAll('[data-afina-info-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-afina-info-pane') !== tab; });
    var title = drawer.querySelector('[data-afina-info-title]');
    /* Shop-language title from snippets/afina-pdp-infohub.liquid (data-afina-title-*), English as fallback */
    if (title) title.textContent = drawer.getAttribute('data-afina-title-' + tab) || INFO_TITLES[tab] || '';
    drawer.querySelectorAll('[data-afina-info-tabs] [data-afina-info]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-afina-info') === tab); });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
    document.documentElement.style.overflow = 'hidden';
  }
  function closeInfoDrawer() {
    var drawer = document.querySelector('[data-afina-info-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    var scrim = document.querySelector('[data-afina-info-scrim]');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ---- Delegated click handling ---- */
  document.addEventListener('click', function (e) {
    var t;

    /* PDP quicklink: Read Reviews → scroll to the reviews section */
    t = e.target.closest('[data-afina-reviews]');
    if (t) {
      var rv = document.getElementById('reviews') || document.querySelector('.fr-clinicians');
      if (rv) window.scrollTo({ top: rv.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
      return;
    }

    /* PDP quicklink/tab: open the InfoDrawer at a tab */
    t = e.target.closest('[data-afina-info]');
    if (t) { openInfoDrawer(t.getAttribute('data-afina-info')); return; }

    /* InfoDrawer: Hair/Skin segmented toggle */
    t = e.target.closest('[data-afina-issue]');
    if (t) {
      var drawer = t.closest('[data-afina-info-drawer]'), which = t.getAttribute('data-afina-issue');
      if (drawer) {
        drawer.querySelectorAll('[data-afina-issue]').forEach(function (b) { b.setAttribute('aria-pressed', b === t); });
        drawer.querySelectorAll('[data-afina-issue-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-afina-issue-pane') !== which; });
      }
      return;
    }

    /* InfoDrawer: close (X or scrim) */
    if (e.target.closest('[data-afina-info-close]') || e.target.closest('[data-afina-info-scrim]')) { closeInfoDrawer(); return; }

    /* Video modal (press bar segments + UGC clips) */
    t = e.target.closest('[data-afina-video]');
    if (t) {
      e.preventDefault();
      var src = t.getAttribute('data-afina-video');
      var poster = t.getAttribute('data-afina-poster') || '';
      var title = t.getAttribute('data-afina-title') || '';
      var caption = t.getAttribute('data-afina-caption') || '';
      openModal(
        '<div class="tvmodal">' +
        '<div class="tvmodal__frame" style="background:#000;border-radius:12px;overflow:hidden;display:flex;align-items:center;justify-content:center"><video src="' + esc(src) + '" poster="' + esc(poster) + '" controls autoplay playsinline style="display:block;width:100%;max-height:70vh;background:#000"></video></div>' +
        (title || caption ? '<div class="tvmodal__meta">' +
          (title ? '<span class="tvmodal__net">' + esc(title) + '</span>' : '') +
          (caption ? '<p>' + esc(caption) + '</p>' : '') + '</div>' : '') +
        '</div>', true);
      return;
    }

    /* Article modal (water-report news ticker + map pins) */
    t = e.target.closest('[data-afina-article]');
    if (t) {
      e.preventDefault();
      var aTitle = t.getAttribute('data-afina-title') || '';
      var aSrc = t.getAttribute('data-afina-src') || '';
      var aBody = t.getAttribute('data-afina-body') || '';
      openModal(
        '<div class="wr__article">' +
        '<span class="wr__articleSrc">' + esc(aSrc) + '</span>' +
        '<h3 class="serif">' + esc(aTitle) + '</h3>' +
        '<p>' + esc(aBody) + '</p>' +
        '<a class="btn btn--primary" href="/pages/water-report">Check my area →</a>' +
        '</div>');
      return;
    }

    /* Water-report CTA → the real report tool page */
    t = e.target.closest('[data-afina-report]');
    if (t) {
      e.preventDefault();
      window.location.href = '/pages/water-report';
      return;
    }

    /* Accordion (tradeoff rows) */
    t = e.target.closest('[data-afina-acc]');
    if (t) {
      var row = t.closest('.tradeoff__row, .acc__item');
      if (!row) return;
      var panel = row.querySelector('.tradeoff__panel, .acc__panel');
      var open = row.classList.toggle('open');
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      // swap +/- icon
      var ic = t.querySelector('[data-afina-acc-icon]');
      if (ic) ic.innerHTML = open
        ? '<path d="M5 12h14"/>'
        : '<path d="M12 5v14M5 12h14"/>';
      return;
    }

    /* Review tabs (real results) */
    t = e.target.closest('[data-afina-tab]');
    if (t) {
      var scope = t.closest('.afina-home');
      var cat = t.getAttribute('data-afina-tab');
      scope.querySelectorAll('[data-afina-tab]').forEach(function (b) {
        b.classList.toggle('active', b === t);
      });
      scope.querySelectorAll('[data-afina-cat]').forEach(function (card) {
        var c = card.getAttribute('data-afina-cat');
        var show = cat === 'All' ? card.getAttribute('data-afina-inall') === '1' : c === cat;
        card.style.display = show ? '' : 'none';
      });
      return;
    }

    /* Rail scroll arrows */
    t = e.target.closest('[data-afina-rail]');
    if (t) {
      var dir = t.getAttribute('data-afina-rail') === 'prev' ? -1 : 1;
      var wrap = t.closest('.ugc__rail-wrap, .pressbar__rail');
      var rail = wrap && wrap.querySelector('.ugc__rail, .pressbar__videos');
      if (rail) rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
  });

  /* Autoplay UGC clips (muted, inline) when scrolled into view so the real
     creator footage is what shows — not a mismatched poster. Pauses offscreen. */
  function initUgcVideos() {
    var vids = document.querySelectorAll('.ugccard__vid');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) { v.load(); v.dataset.loaded = '1'; }
          var p = v.play();
          if (p && p.then) p.then(function () { v.dataset.ready = '1'; }).catch(function () {
            // autoplay blocked (e.g. iOS Low Power Mode) — still paint the first frame
            try { if (v.currentTime === 0) v.currentTime = 0.1; } catch (err) {}
          });
          else v.dataset.ready = '1';
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') initUgcVideos();
  else document.addEventListener('DOMContentLoaded', initUgcVideos);

  /* The Alia popup app mounts a transparent full-viewport root
     (position:fixed; inset:0; z-index:2147483647) that can sit in the DOM
     with nothing visible inside it — swallowing every click on the page
     (video modals, map pins, buttons). Its UI lives in a shadow root, so a
     CSS pointer-events override would also kill the popup itself. Instead:
     while the root covers the viewport but paints nothing, let clicks pass
     through; the moment real popup content appears, restore clicks. */
  function guardAliaRoot(root) {
    if (root.dataset.afinaGuard || !root.shadowRoot) return;
    root.dataset.afinaGuard = '1';
    var update = function () {
      var covers = root.offsetWidth >= window.innerWidth * 0.9 &&
                   root.offsetHeight >= window.innerHeight * 0.9;
      var visible = false;
      root.shadowRoot.querySelectorAll('div').forEach(function (el) {
        if (visible) return;
        var r = el.getBoundingClientRect();
        if (r.width <= 80 || r.height <= 80) return;
        // getBoundingClientRect still reports a box for opacity:0 / visibility:hidden
        // / hidden-ancestor elements — Alia keeps a full-size container mounted while
        // idle, which would falsely read as "visible" and keep the overlay swallowing
        // clicks. Only count it if it's actually painted.
        if (typeof el.checkVisibility === 'function') {
          if (el.checkVisibility({ opacityProperty: true, visibilityProperty: true, contentVisibilityAuto: true })) visible = true;
        } else {
          var cs = window.getComputedStyle(el);
          if (cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0) visible = true;
        }
      });
      root.style.pointerEvents = (covers && !visible) ? 'none' : '';
    };
    update();
    new MutationObserver(update).observe(root.shadowRoot, { childList: true, subtree: true, attributes: true });
    new MutationObserver(update).observe(root, { attributes: true });
  }
  function scanOverlayApps() {
    document.querySelectorAll('[id^="alia-root"]').forEach(guardAliaRoot);
  }
  function initOverlayGuard() {
    scanOverlayApps();
    new MutationObserver(scanOverlayApps).observe(document.body, { childList: true });
    // the app attaches its shadow root after inserting the node — retry a few times
    setTimeout(scanOverlayApps, 2000);
    setTimeout(scanOverlayApps, 6000);
  }
  if (document.readyState !== 'loading') initOverlayGuard();
  else document.addEventListener('DOMContentLoaded', initOverlayGuard);

  /* Draggable before/after filter reveal ([data-afina-dba], PDP "filter after 3 months"). */
  function initDba() {
    document.querySelectorAll('[data-afina-dba]').forEach(function (el) {
      if (el.dataset.dbaInit) return; el.dataset.dbaInit = '1';
      var before = el.querySelector('.dba__before'), divr = el.querySelector('.dba__div'), dragging = false;
      function setW() { el.style.setProperty('--dba-w', el.clientWidth + 'px'); }
      setW(); window.addEventListener('resize', setW);
      function move(clientX) {
        var r = el.getBoundingClientRect();
        var pos = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
        if (before) before.style.width = pos + '%';
        if (divr) divr.style.left = pos + '%';
      }
      el.addEventListener('pointerdown', function (e) { dragging = true; try { el.setPointerCapture(e.pointerId); } catch (x) {} move(e.clientX); });
      el.addEventListener('pointermove', function (e) { if (dragging) move(e.clientX); });
      el.addEventListener('pointerup', function () { dragging = false; });
      el.addEventListener('pointercancel', function () { dragging = false; });
    });
  }
  if (document.readyState !== 'loading') initDba();
  else document.addEventListener('DOMContentLoaded', initDba);
})();
